import { Avatar, Descriptions, Modal, Typography } from "antd";
import { servicesUrlConfig } from "shared/config/setting";

const { Text } = Typography;

/**
 * Read-only details of a robot attached to an organization.
 *
 * The organization robots payload carries the robot's api_key for every
 * member, so it is only rendered when the viewer may see it.
 *
 * @param {Object} robot - Robot record from GET /orgs/{id}/robots
 * @param {boolean} canViewApiKey - Reveal the API key (org admins only)
 * @param {Function} translate - Translation function (i18n key -> string)
 */
export const RobotDetailModal = ({
  visible,
  robot,
  canViewApiKey = false,
  onClose,
  translate = (key) => key,
}) => {
  const iconUrl = servicesUrlConfig.ROBOTS_API.getStaticUrl(
    robot?.icon_path ??
      robot?.robot_type?.icon_path ??
      "/robot_type_icons/unknown_robot_type.png",
  );

  return (
    <Modal
      title={`${translate("organizations.robotDetails")}: ${robot?.robot_id || ""}`}
      open={visible}
      onCancel={onClose}
      footer={null}
    >
      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label={translate("organizations.robotId")}>
          {robot?.robot_id}
        </Descriptions.Item>
        <Descriptions.Item label={translate("organizations.name")}>
          {robot?.name || translate("organizations.noname")}
        </Descriptions.Item>
        <Descriptions.Item label={translate("organizations.type")}>
          {robot?.robot_type?.name || translate("organizations.unknown")}
        </Descriptions.Item>
        <Descriptions.Item label={translate("organizations.apiKey")}>
          {canViewApiKey ? (
            <Text copyable={!!robot?.api_key}>
              {robot?.api_key || translate("organizations.notAvailable")}
            </Text>
          ) : (
            <Text type="secondary">
              {translate("organizations.notAllowedToView")}
            </Text>
          )}
        </Descriptions.Item>
        <Descriptions.Item label={translate("organizations.avatar")}>
          <Avatar className="shape-avatar" shape="square" size={64} src={iconUrl} />
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};
